module.exports = __webpack_public_path__ + "media/src/images/partners/glu-b1431ef791e45ab7166f260125e6cb6d.jpg";